export default "__VITE_ASSET__D0MD8fye__"